import { render, staticRenderFns } from "./VehiculeOverview.vue?vue&type=template&id=1849c752&scoped=true&"
import script from "./VehiculeOverview.vue?vue&type=script&lang=js&"
export * from "./VehiculeOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1849c752",
  null
  
)

export default component.exports